/****
 * Triggering animations using
 */

// Ratio of viewport that elements should be fully faded in by
const fadeInRatio = 0.4;

// Initialize all elements with fade-in class to hidden
document.querySelectorAll('.is-style-fade-in').forEach((el) => {
    el.style.opacity = 0;
    el.style.transition = 'opacity 1s ease';
});

intersectionCallback = (entries) => {

    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
        }
        else {
            entry.target.classList.remove('in-view');
        }
    });
};

// Create an intersection observer that checks in 10% intervals
let options = {
    root: null,
    rootMargin: "0px",
    threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
};
const observer = new IntersectionObserver(intersectionCallback, options);


// Find the elements we need to animate
const animElements = document.querySelectorAll('.is-style-fade-in');
animElements.forEach((el) => observer.observe(el));
